import { InfiniteList } from "components/list/infinity-list";
import { IGrantVestmentInteraction } from "interfaces/grant-vestment-interaction";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { Box } from "@mui/material";
import UserAvatar from "components/card/UserAvatar";
import React, { useEffect, useState, useRef } from "react";
import { shortFormat } from "utils/date-format";

interface GrantVestmentLikesListProps {
  grantVestmentId?: number;
  grantVestmentName?: string;
  userName?: string;
  liked?: boolean;
  disliked?: boolean;
  onDataUpdate?: (data: any[]) => void;
  startDate?: string | null; // Changed from Date to string for formatted date
  endDate?: string | null; // Changed from Date to string for formatted date
}

export const GrantVestmentLikesList: React.FC<GrantVestmentLikesListProps> = ({
  grantVestmentId,
  grantVestmentName,
  userName,
  liked,
  disliked,
  onDataUpdate,
  startDate,
  endDate,
}) => {
  const [shouldRefetch, setShouldRefetch] = useState(false);
  const [grantVestment, setGrantVestment] = useState<
    IGrantVestmentInteraction[]
  >([]);

  // Store previous data to compare and prevent unnecessary updates
  const prevDataRef = useRef<string>("");

  // Only create the exported data when grantVestment changes
  useEffect(() => {
    if (grantVestment.length === 0) return;

    const exportedData = grantVestment.map((item) => ({
      Name: `${item.user.firstName} ${item.user.lastName} `,
      Email: item.user.email,
      GrantVestment: item.grantVestment.name,
      Liked: item.liked ? "Yes" : "No",
      createdAt: shortFormat(item.createdAt),
    }));

    // Convert to string to compare with previous data
    const dataString = JSON.stringify(exportedData);

    // Only update if data has changed
    if (dataString !== prevDataRef.current) {
      prevDataRef.current = dataString;

      // Use setTimeout to break the render cycle
      setTimeout(() => {
        if (onDataUpdate) {
          onDataUpdate(exportedData);
        }
      }, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grantVestment]);

  const handleRefetchComplete = () => {
    setShouldRefetch(false);
  };
  console.log(startDate, endDate);
  return (
    <Box>
      <InfiniteList<IGrantVestmentInteraction>
        endpoint={`grantvestment-interaction`}
        queryParams={{
          ...(grantVestmentId && {
            "filter[grantvestmentId]": `${grantVestmentId}`,
          }),
          ...(grantVestmentName && {
            "filter[grantvestmentName]": grantVestmentName,
          }),
          ...(userName && { "filter[username]": userName }),
          ...(liked !== undefined &&
            liked === true &&
            disliked === false && { "filter[liked]": true }),
          ...(disliked !== undefined &&
            disliked === true &&
            liked === false && { "filter[liked]": false }),
          ...(startDate && {
            "filter[startDate]": startDate,
          }),
          ...(endDate && {
            "filter[endDate]": endDate,
          }),
        }}
        isTable={true}
        limit={10}
        columns={[
          {
            field: "user",
            header: "User",
            renderCell: function render({ user }) {
              return <UserAvatar user={user} />;
            },
          },
          {
            field: "user",
            header: "Email",
            renderCell: function render({ user }) {
              return user.email;
            },
          },
          {
            header: "GrantVestment",
            renderCell: function render({ grantVestment }) {
              return grantVestment.name;
            },
          },
          {
            header: "Date",
            renderCell: function render({ createdAt }) {
              return shortFormat(createdAt);
            },
          },
          {
            header: "Liked",
            renderCell: function render({ liked }) {
              return liked ? (
                <ThumbUpIcon
                  sx={{
                    color: "primary.main",
                    fontSize: "1.5rem",
                  }}
                />
              ) : (
                <ThumbDownIcon
                  sx={{
                    color: "grey.400",
                    fontSize: "1.5rem",
                  }}
                />
              );
            },
          },
        ]}
        tableProps={{
          stickyHeader: true,
          headerBgColor: "grey.200",
          responsive: true,
        }}
        onRefetchTrigger={shouldRefetch}
        onRefetchComplete={handleRefetchComplete}
        onDataChange={(data) => {
          setGrantVestment(data);
        }}
      />
    </Box>
  );
};
